module.exports = __webpack_public_path__ + "static/media/wearable.ff7383e6.svg";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/pages/experiences/resources/onboardig/svg/wearable.svg
// module id = 3844
// module chunks = 0